import React from 'react';

const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');

// Letreiro rolando (igual ao da Roleta): últimos ganhadores do evento — apelido + ID mascarado, vindo do servidor
export const RpWinnersMarquee = ({ recent }) => {
  if (!recent || recent.length === 0) return null;
  return (
    <div className="relative mb-3 overflow-hidden rounded-xl border border-lime-400/40 bg-gradient-to-r from-lime-500/10 via-fuchsia-500/15 to-lime-500/10 py-1.5" data-testid="rp-winners-marquee">
      <div className="flex w-max whitespace-nowrap" style={{ animation: `rp-marquee ${Math.max(18, recent.length * 5)}s linear infinite` }}>
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center">
            {recent.map((w) => (
              <span key={`${dup}-${w.prize_id}`} className="mx-4 inline-flex items-center gap-1.5 text-xs font-black text-lime-200"
                data-testid={dup === 0 ? 'rp-marquee-item' : undefined}>
                {w.avatar ? <img src={w.avatar} alt="" className="h-5 w-5 rounded-full border border-fuchsia-400/70 object-cover" /> : '🎁'}
                {w.nickname} <span className="font-normal text-fuchsia-300/80">({w.kako_masked})</span>
                <span className="text-purple-200/80">ganhou</span>
                <img src={`/rp/${w.prop_id}.png`} alt="" className="h-5 w-5 object-contain" />
                <span className="text-amber-300">{w.gift_name} 🪙{fmt(w.coins)}</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RpWinnersMarquee;
